import type { CardProps } from '@designsystem/stories/03-molecules/Card';
import type { MediaProps } from '@designsystem/stories/02-atoms/Media';
import { normalizeContent } from '@fhnw/helpers/DesignSystem/normalizeContent';
import { Testimonial } from '../View';
import { getListingImageSizes } from '@fhnw/helpers/DesignSystem/imageSizes';

function getTitle(item: Testimonial) {
  return item?.title ?? (item as any)?.Title ?? '';
}

function getDescription(item: Testimonial) {
  return item?.description ?? (item as any)?.Description ?? undefined;
}

export function testimonialToCard(
  item: Testimonial,
  prominent?: boolean,
): CardProps {
  const type: CardProps['type'] = prominent
    ? 'testimonial-prominent'
    : 'testimonial';
  const img: MediaProps | undefined = (
    normalizeContent(
      item?.image,
      false,
      getListingImageSizes(type, undefined, true),
    ) as { image?: MediaProps }
  )?.image;
  if (img) {
    img.focus_point = item.focus_point as MediaProps['focus_point'];
  }
  const avatar = item?.name
    ? img
      ? { name: item.name, image: img }
      : { name: item.name }
    : undefined;

  return {
    type: type,
    title: getTitle(item),
    description: getDescription(item),
    avatar,
  };
}
